import { endpoints } from "../../config/apiEndpoint";
import { apiClient } from "../shared/apiClient";

/**
 * Fetches all active locations.
 *
 * @return {Promise<{data: any, success: boolean}>} A promise that resolves with the locations.
 */
export async function fetchAllLocation() {
  return apiClient.get(endpoints.locations.active, {}, false);
}
